module.exports = __webpack_public_path__ + "img/Group2049.ee05a78c.png";